import { render, staticRenderFns } from "./CoursePractice.vue?vue&type=template&id=2d797b00&"
import script from "./CoursePractice.vue?vue&type=script&lang=js&"
export * from "./CoursePractice.vue?vue&type=script&lang=js&"
import style0 from "./CoursePractice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports